import React from 'react';
import { Box } from '@mui/material';
import {
  fileTypeByUrl,
  getFileFormat,
} from '@/components/file-thumbnail/utils';
import LegacyFileCard, { LegacyFileCardStatus } from './LegacyFileCard';
import PdfPreview from './PdfPreview';

export type ApprovalAttachmentItemData = {
  readonly name: string;
  readonly link?: string;
  readonly status?: LegacyFileCardStatus;
  readonly fileUuid?: string;
  readonly fileSize?: number | string;
  readonly createdAt?: string | Date;
};

export type ApprovalAttachmentItemProps = ApprovalAttachmentItemData & {
  readonly onRemove?: () => void;
};

/**
 * 단건 품의 첨부 — pdf 면 PdfPreview, 그 외는 LegacyFileCard.
 * 포맷 판정은 포탈 기존 헬퍼(getFileFormat(fileTypeByUrl(name))) 재사용.
 */
export const ApprovalAttachmentItem = ({
  name,
  link,
  status,
  onRemove,
}: ApprovalAttachmentItemProps) => {
  const isPdf = getFileFormat(fileTypeByUrl(name)) === 'pdf';

  if (isPdf) {
    return (
      <PdfPreview name={name} link={link} status={status} onRemove={onRemove} />
    );
  }

  return (
    <LegacyFileCard
      name={name}
      link={link}
      status={status}
      onRemove={onRemove}
    />
  );
};

export type ApprovalAttachmentListProps = {
  readonly items: ApprovalAttachmentItemData[];
  readonly onRemove?: (item: ApprovalAttachmentItemData) => void;
};

/** 품의 코멘트 첨부 래퍼 컴포넌트 */
const ApprovalAttachmentList = ({
  items,
  onRemove,
}: ApprovalAttachmentListProps) => {
  if (!items.length) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px',
        maxWidth: '100%',
        margin: '4px 0',
      }}
    >
      {items.map((item, i) => (
        <ApprovalAttachmentItem
          key={`${item.link || item.name}-${i}`}
          name={item.name}
          link={item.link}
          status={item.status}
          onRemove={onRemove ? () => onRemove(item) : undefined}
        />
      ))}
    </Box>
  );
};

export default ApprovalAttachmentList;
